import { Component } from '@angular/core';
import { PostsService } from './modules/core/services/posts.service';
import { Natjecaj } from './model';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'edonacijeweb-front';

  constructor(
    public postsService: PostsService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.dohvatiAktivanNatjecaj();
  }

  dohvatiOibUrl(): void {
    this.postsService.getOibUrl().subscribe({
      next: (data: any) => {
        if (data?.length && data[0].oibserver) {
          this.postsService.oibUrl = data[0].oibserver;
        } else {
          console.warn('Nema oibserver vrijednosti u odgovoru:', data);
        }
      },
      error: (error) => {
        console.error('Greška pri dohvaćanju OIB URL-a:', error);
        this.router.navigate(['/error']);
      }
    });
  }

  dohvatiAktivanNatjecaj(): void {
    this.postsService.getAktivanNatjecaj().subscribe({
      next: (data: Natjecaj) => {
        this.postsService.natjecaj = data;
        
        if (data.aktivan === 0) {
          this.dohvatiNatjecajGodina();
        } else if (data.aktivan === 1) {
          this.dohvatiOibUrl();
        } else {
          this.router.navigate(['/error']);
        }
      },
      error: (error) => {
        console.error('Greška pri dohvaćanju aktivnog natječaja:', error);
        this.postsService.status = 'ERROR'
        this.router.navigate(['/error']);
      }
    });
  }

  dohvatiNatjecajGodina(): void {
    const godina = new Date().getFullYear();
    
    this.postsService.getNatjecajGodina(godina).subscribe({
      next: (data: Natjecaj) => {
        this.postsService.natjecaj.natjecajNeaktivanTekst = data.natjecajNeaktivanTekst;
        this.router.navigate(['/not-active']);
      },
      error: (error) => {
        console.error('Greška pri dohvaćanju natječaja po godini:', error);
        this.router.navigate(['/error']);
      }
    });
  }
}